export default {
  container: {
    display: 'block',
    marginTop: '20px'
  },
  text: {
    display: 'inline-block',
    minWidth: '150px',
    marginRight: '20px',
    textAlign: 'right',
  },
  value: {
    display: 'inline-block',
    maxWidth: '600px',
    wordBreak: 'break-all',
    wordWrap: 'break-work',
    verticalAlign: 'top'
  },
  require: {
    color: '#f00'
  },
  inline: {
    display: 'inline-block'
  },
  after: {
    marginLeft: 6
  }
};



// WEBPACK FOOTER //
// ./src/Parts/EditPart/style.js